import { useUIState, useUISetters } from "@vc/contexts/UIStateContext";

export function useMeetingDialogs() {
  const state = useUIState();
  const setters = useUISetters();

  return {
    settingsOpen: state.settingsOpen, setSettingsOpen: setters.setSettingsOpen,
    helpOpen: state.helpOpen, setHelpOpen: setters.setHelpOpen,
    aboutOpen: state.aboutOpen, setAboutOpen: setters.setAboutOpen,
    shortcutsOpen: state.shortcutsOpen, setShortcutsOpen: setters.setShortcutsOpen,
    reportOpen: state.reportOpen, setReportOpen: setters.setReportOpen,
    hostControlsOpen: state.hostControlsOpen, setHostControlsOpen: setters.setHostControlsOpen,
    addVideoInputOpen: state.addVideoInputOpen, setAddVideoInputOpen: setters.setAddVideoInputOpen,
    whiteboardOpen: state.whiteboardOpen, setWhiteboardOpen: setters.setWhiteboardOpen,
    pollsPanelOpen: state.pollsPanelOpen, setPollsPanelOpen: setters.setPollsPanelOpen,
    createPollOpen: state.createPollOpen, setCreatePollOpen: setters.setCreatePollOpen,
    createSurveyOpen: state.createSurveyOpen, setCreateSurveyOpen: setters.setCreateSurveyOpen,
    pollVotingOpen: state.pollVotingOpen, setPollVotingOpen: setters.setPollVotingOpen,
    pollResultsOpen: state.pollResultsOpen, setPollResultsOpen: setters.setPollResultsOpen,
    surveysPanelOpen: state.surveysPanelOpen, setSurveysPanelOpen: setters.setSurveysPanelOpen,
    brandingPanelOpen: state.brandingPanelOpen, setBrandingPanelOpen: setters.setBrandingPanelOpen,
    videoSharePanelOpen: state.videoSharePanelOpen, setVideoSharePanelOpen: setters.setVideoSharePanelOpen,
    documentSharePanelOpen: state.documentSharePanelOpen, setDocumentSharePanelOpen: setters.setDocumentSharePanelOpen,
    transcriptionPanelOpen: state.transcriptionPanelOpen, setTranscriptionPanelOpen: setters.setTranscriptionPanelOpen,
    backgroundEffectsOpen: state.backgroundEffectsOpen, setBackgroundEffectsOpen: setters.setBackgroundEffectsOpen,
    liveStreamingOpen: state.liveStreamingOpen, setLiveStreamingOpen: setters.setLiveStreamingOpen,
    engagementControlsOpen: state.engagementControlsOpen, setEngagementControlsOpen: setters.setEngagementControlsOpen,
    endWebinarDialogOpen: state.endWebinarDialogOpen, setEndWebinarDialogOpen: setters.setEndWebinarDialogOpen,
    adjustViewOpen: state.adjustViewOpen, setAdjustViewOpen: setters.setAdjustViewOpen,
    chatOpen: state.chatOpen, setChatOpen: setters.setChatOpen,
    participantsOpen: state.participantsOpen, setParticipantsOpen: setters.setParticipantsOpen,
    webinarUsersOpen: state.webinarUsersOpen, setWebinarUsersOpen: setters.setWebinarUsersOpen,
    filesOpen: state.filesOpen, setFilesOpen: setters.setFilesOpen,
    meetingInfoPanelOpen: state.meetingInfoPanelOpen, setMeetingInfoPanelOpen: setters.setMeetingInfoPanelOpen,
    closeAllPanels: setters.closeAllPanels,
  };
}
